<template>
    <div>
        <basic-container>
        <el-form :model="selectForm" ref="searchFormRef" label-suffix=':' label-width="100px"  v-show="searchBoxFlag" >
         <el-row :gutter="24">
             <el-col :span="6">
                          <el-form-item label="项目名称" prop="projectId"  >
                              <el-select v-model="selectForm.projectId" style="width:100%" placeholder="请选择" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
             <el-col :span="6">
                <el-form-item label="设备编号" prop="checkPass">
                        <el-input clearable v-model="selectForm.code" placeholder="设备编号" maxlength="20"></el-input>
                </el-form-item>
            </el-col>

            <el-col :span="6">
                <el-form-item label="设备名称" prop="checkPass">
                    <el-input clearable v-model="selectForm.deviceName" placeholder="设备名称" maxlength="20"></el-input>
                </el-form-item>
            </el-col>
             <el-col :span='6' >
                 <el-form-item label="设备类型" prop="objectType">
                    <el-select
                    ref="typeIdSelect"
                    clearable
                    @clear="objectTypeClear"
                    :disabled="!objectTypeFlag"
                    :value="selectForm.typeId"
                    v-model="selectForm.typeId"
                    placeholder="设备类型"
                    style="width: 100%;"
                    >
                    <el-option :value="selectForm.typeId" show-all-levels :label="selectForm.typeName">
                        <el-tree
                        node-key="id"
                        :data="treeFormData"
                        :props="treeProps"
                        
                        @node-click="typeNodeTreeClick"
                        >
                        </el-tree>
                    </el-option>
                    </el-select>
                </el-form-item>
             </el-col>
            
            <el-col :span="6">
                <el-form-item label="所属部门" prop="deptId">
                    <el-select  
                    clearable 
                    @clear="deptClear"
                        :disabled="!deptIdFlag"       
                        :value="selectForm.deptName"
                        placeholder="所属部门"
                        style="width: 100%;"
                        filterable 
                        @focus="showDetpTree=true"
                        >
                        <el-option v-show="showDetpTree" :value="selectForm.deptName" show-all-levels :label="selectForm.deptName">
                            <el-tree
                            node-key="id"
                            :data="treeFormDeptData"
                            :props="treeDeptProps"
                                @node-click="handleDeptNodeClick"
                            >
                            </el-tree>
                        </el-option>
                        </el-select>
                    </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="存放位置" prop="areaId">
                    <el-select
                    clearable
                    @clear="areaClear"
                    :disabled="!areaIdFlag"
                    :value="selectForm.areaName"
                    placeholder="存放区域"
                    style="width: 100%;"
                >
                    <el-option :value="selectForm.areaName" show-all-levels :label="selectForm.areaName">
                    <el-tree
                        node-key="id"
                        :data="treeFormAreaData"
                        :props="areaTreeProps"
                        :load="areaLazyLoadTree"
                        lazy
                        @node-click="areaNodeTreeClick"
                    >
                    </el-tree>
                    </el-option>
                </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="巡检日期">
                     <el-date-picker
                                  style="width: 100%"
                                  clearable
                                  v-model="selectForm.timeRange"
                                  value-format="yyyy-MM-dd"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  >
                              </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                 <el-form-item label="巡检人" prop="realInspectManName">
                        <el-input clearable v-model="selectForm.realInspectManName" placeholder="巡检人" maxlength="20"></el-input>
                </el-form-item>
            </el-col>
             <el-col :span="6">
                 <el-form-item label="巡检结果" prop="checkPass">
                       <el-select clearable v-model="selectForm.errorFlag" style="width:100%" placeholder="巡检结果" >
                                  <el-option
                                      v-for="item in inspectionResultList"
                                       :key="item.errorFlag"
                                      :label="item.name"
                                      :value="item.errorFlag">
                                  </el-option>
                              </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <div style="float:right">
                              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small"> 搜索 </el-button>
                              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
                </div>
            </el-col>

          
        </el-row>
        </el-form>
        <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            ref="crud"
              @on-load="onLoad"
               @selection-change="selectionChange"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad">
            <template slot="menuLeft">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord"> 新 增</el-button>
                <exportData :moduleType="400" @exportExcel="exportExcel"></exportData>
                <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="delConstractInvoice">删除</el-button> -->
            </template>
            <template slot="menuRight">
              <searchFromShow
                :searchBoxFlag.sync='searchBoxFlag'
                :removeHeight ='searchHeight'
                :option='option'
               reduceHeight='30'
                :refOption="$refs.crud"
                ></searchFromShow>
            
            </template>
           <template slot-scope="scope" slot="menu">
            <el-button
                type="text"
                size="small"
                icon="el-icon-tickets"
                @click="checkRecord(scope.row)"
                >查看
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                
                @click="editRecord(scope.row)"
                >编辑
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
               
                @click="removeRecord(scope.row.id)"
                >删除
            </el-button>
            </template>
        </avue-crud>
        </basic-container>
      
        
        <addInspectionRecord2 
        v-if="addOrEditFlag"
        :dialogVisible.sync="addOrEditFlag" 
        :handleClose ='handleClose'
        :title="dialogTitle"
        :operatorModel='operatorModel' 
        :projectId="selectForm.projectId"
        :projectList='projectList'
        :row='row'
        @successCallBack="successCallBack"
        ></addInspectionRecord2>
    </div>
</template>

<script>
import {getInspectionList, watchInspectRecordRecord,removeInspectRecord} from '@/api/crmedical/device/deviceInspectionStandard'
import { getProjectList } from '@/api/crmedical/project/project';
import { tree } from '@/api/crmedical/device/devicetype';
import { lazyAreaTree } from '@/api/crmedical/order/order-list/order-list';
import { lazyTree } from '@/api/crmedical/project/area';
import { treeByProjectDeptId } from '@/api/crmedical/device/device';
import addInspectionRecord from '@/components/device/deviceInspectionRecord/deviceInspectionRecord.vue';
// import addInspectionRecord2 from '@/components/device/deviceInspectionRecord/deviceInspectionRecordIncludeDialog.vue';
import addInspectionRecord2 from '@/components/device/deviceInspectionRecord/deviceInspect.vue';
import searchFromShow from '@/components/search-form-show/index'
import exportData from "@/components/exportData/exportDataSimple";
 import {getToken} from '@/util/auth';
export default {
  components: {
    addInspectionRecord,
    searchFromShow,
    addInspectionRecord2,
    exportData
  },
  data() {
    return {
      inspectionResultList: [
        {
          errorFlag: 1,
          name: '异常',
        },
        {
          errorFlag: 0,
          name: '正常',
        },
      ],
      row:{},
      searchBoxFlag:true,
      searchHeight:'',
      isWatch:false,
      areaIdFlag:true,
      deptIdFlag:true,
      objectTypeFlag:true,
      showDetpTree:false,
      addOrEditFlag: false,
      dialogTitle: '新增',
      isEdit: true,
      data: [],
      form:{
        projectId:'',
        attachList:[]
      },
      selectForm: {
        projectId:'',
        objectType: '',
        deviceName: '',
        deptId: '',
        areaId: '',
        deptName: '',
        areaName: '',
        typeId: '',
        typeName: '',
        startTime:'',
        endTime:'',
        realInspectManName:'',
        errorFlag:'',
        timeRange:[]
      },
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'children',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'title',
      },
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      areaTreeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      treeFormAreaData: [], //所属区域
      treeFormDeptData: [], //所属部门
      treeFormData: [], //设备类型
      deviceList: [],
      option: {
        selection: true,
        index:true,
        indexLabel: '序号',
        page: true,
        height: 'auto',
        calcHeight:'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '项目名称',
            prop: 'projectName',
          },
         
          {
            label: '设备类型',
            prop: 'deviceType',
          },
          {
            label: '设备编号',
            prop: 'code',
          },
          {
            label: '设备名称',
            prop: 'deviceName',
          },
          
          {
            label: '所属部门',
            prop: 'deptName',
          },
          {
            label: '存放位置',
            prop: 'areaName',
          },
          {
            label: '巡检人',
            prop: 'realInspectManName',
         
          },
          {
            label: '巡检时间',
            prop: 'realInspectTime',
            format: 'yyyy-MM-dd HH:mm:ss',
            type: 'date',
          },
          {
            label: '巡检结果',
            prop: 'errorFlag',
             dicData: [{ name: '正常', errorFlag: 0 }, { name: '异常', errorFlag: 1 }],
            props: {
              value: 'errorFlag',
              label: 'name',
            },
          },
           {
            label: '工单编号',
            prop: 'orderCode',
            width:'160'
          },
          {
            label: '备注',
            prop: 'description',
            // hide:true
          },
        ],
      },
      page: {
                pageSize: 10,
                currentPage: 1,
                total: 0,
            },
      loading:false,
      operatorModel:'add',
      recordIds:[],
      exportForm:{}
    };
  },
  created() {
    console.log('1111', this.projectId);
    this.initData();
  },
  watch:{
    addOrEditFlag(){
      console.log("父组件的addOrEditFlag",this.addOrEditFlag)
    }
  },
  mounted(){
      this.calcHeight()
    },
  methods: {
    selectionChange(val){
      this.recordIds = []
      val.forEach(element => {
        this.recordIds.push(element.id)
      });
    },
     exportExcel(data) {
       let params = this.tool.formateObjToParamStr(this.exportForm)
        let saveIds = data.exportExcelSelectionRadio=='1'?'':this.recordIds;
      
      if(saveIds.length==0 && data.exportExcelSelectionRadio == 2){
              this.$message({
                      message:'请选择需要导出的数据！',
                      type: 'warning'
              });
              return;
      }
        this.$confirm("是否导出设备巡检数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //导出数据
            let projectId =this.exportForm.projectId ?this.exportForm.projectId:this.searchForm.projectId;

            if(data.exportExcelSelectionRadio == 2){
              this.tool.downloadFile(`/api/deviceinspecttasklist/inspectExport?${
                  this.website.tokenHeader
                }=${getToken()}&projectId=${projectId}&ids=${saveIds}`)
              
            }else{
              // 将条件参数拼接为路由传参格式
             
              // 
              this.tool.downloadFile(
                `/api/deviceinspecttasklist/inspectExport?${
                  this.website.tokenHeader
                }=${getToken()}&ids=&`+params,"abc.xlsx",'xlsx/xls'
                )
             
            }

          });
      },
    successCallBack(){
      this.onLoad()
    },
    calcHeight(){
      this.searchHeight = this.$refs.searchFormRef .$el.clientHeight+30
      this.option.height = this.bodyHeight - this.searchHeight-279; 
    },
    areaClear(){
      this.selectForm.areaName=""
      this.selectForm.areaId=""
    },
    deptClear(){
      this.selectForm.deptName=""
      this.selectForm.deptId=""
    },
    objectTypeClear(){
      this.selectForm.typeId=""
      this.selectForm.typeName=""
    },
    searchClear(){
      this.selectForm.objectType=""
      this.selectForm.name=""
      this.selectForm.deptId=""
      this.selectForm.areaId=""
      this.selectForm.deptName=""
      this.selectForm.areaName=""
      this.selectForm.typeId=""
      this.selectForm.typeName=""
      this.selectForm.code=""
      this.selectForm.timeRange = []
      this.selectForm.realInspectManName = ''
      this.selectForm.errorFlag=''
    },
    cancelOperate(){
      this.addOrEditFlag = false
    },
    submitOver(){
      this.onLoad()
      this.addOrEditFlag = false
    },
    removeRecord(id){
       this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removeInspectRecord(id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.onLoad();
        });
      });
    },
    editRecord(row){
      this.row = row
       this.operatorModel = "update"
      this.dialogTitle = "编辑巡检记录"
      this.addOrEditFlag = true
       
  
    },
    checkRecord(row){
      this.operatorModel = "view"
      this.dialogTitle = "巡检记录查看"
      this.row = row
      this.addOrEditFlag = true
      // watchInspectRecordRecord({id:id}).then(({data})=>{
      //   this.form = data
      //   // this.$set(this.form,"realInspectTime",data.realInspectTime)
      //   // paymentrecordImg({mainId:row.id})
      //    this.addOrEditFlag = true
      // })
     
    },
    handleClose(){
      this.form ={}
     this.addOrEditFlag = false
    
    },
    searchRecord(){
      this.page.currentPage = 1
       if(this.selectForm.timeRange&&this.selectForm.timeRange.length>0){
                this.selectForm.startTime = this.dayjs(this.selectForm.timeRange[0]).format('YYYY-MM-DD 00:00:00')
                this.selectForm.endTime = this.dayjs(this.selectForm.timeRange[1]).format('YYYY-MM-DD 23:59:59') 
            }else{
                this.selectForm.timeRange = []
                this.selectForm.startTime = ''
                  this.selectForm.endTime = ''
            }
      this.onLoad()
    },
    projectIdChange(){
      this.areaIdFlag=false
      this.deptIdFlag=false
      this.objectTypeFlag=false
     
      this.selectForm.deptId=""
      this.selectForm.areaId=""
      this.selectForm.deptName=""
      this.selectForm.areaName=""
      this.selectForm.typeId=""
      this.selectForm.typeName=""
      this.queryAreaSelect(this.selectForm.projectId);
      this.treeByProjectDeptId(this.selectForm.projectId);
      this.queryDeviceSelect(this.selectForm.projectId);
    },
      //添加巡检记录
      addRecord(){
          this.isEdit = true
          this.isWatch=false
           this.operatorModel = "add"
          this.dialogTitle = "新增"
          console.log("新增")
          this.form = {}
          this.addOrEditFlag = true
          this.form.projectId = this.selectForm.projectId
      },
    onLoad() {
     
            this.loading = true;
            if(this.selectForm.projectId){
                this.exportForm = Object.assign({},this.selectForm)
              getInspectionList(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, this.selectForm)).then(({data})=>{
                this.data = data.records
                this.page.total = data.total
                this.loading = false;
            }).catch(()=>{
                this.loading = false;
            })
            }else{
              this.loading = false;
            }
            
    },
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.$set(this.selectForm, 'projectId', this.projectList[0].id);
          this.projectId = this.projectList[0].id;
          this.queryAreaSelect(this.selectForm.projectId);
          this.treeByProjectDeptId(this.selectForm.projectId);
          this.queryDeviceSelect(this.selectForm.projectId);
          this.onLoad();
        }
      });
    },
    getObjectTypeName(dictKey) {
      let ObjectTypeName;
      this.objectType.forEach((element) => {
        if (element.dictKey == dictKey) {
          ObjectTypeName = element.dictValue;
        }
      });
      return ObjectTypeName;
    },

    queryAreaSelect(value) {
      lazyTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
            if (item.nodeType === 1) {
              item.disabled = true;
            }
          });
        }
        this.areaIdFlag = true
        this.treeFormAreaData = data;
      });
    },
    queryDeviceSelect(value) {
      tree({ id: 0, projectId: value, objectType: 1 }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.objectTypeFlag = true
        this.treeFormData = data;
      });
    },
    typeNodeTreeClick(node) {
      console.log(node);
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm = Object.assign({},this.selectForm,{
        typeName:nodeTitle,
        typeId:nodeId
      });
        this.$refs.typeIdSelect.blur();
      // this.selectForm.typeName = nodeTitle;
      // this.selectForm.typeId = nodeId;
          this.$forceUpdate();
    },
    areaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      if(this.selectForm.projectId){
        lazyAreaTree({ parentId: id, projectId: this.selectForm.projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        resolve(data);
      });
      }
    },
    areaNodeTreeClick(node) {
      // if (parseInt(node.nodeType) == 1) {
      //   // this.$message.error();
      //   return;
      // }
      let nodeId = node.id;
      let nodeTitle = node.name;
      this.selectForm.areaName = nodeTitle;
      this.selectForm.areaId = nodeId;
    },
    treeByProjectDeptId(value) {
      treeByProjectDeptId({ projectId: value }).then((res) => {
        this.treeFormDeptData = res.data;
        this.deptIdFlag = true
      });
    },
    handleDeptNodeClick(node) {
      //  if (parseInt(node.nodeType) == 1) {
      //     // this.$message.error();
      //     return;
      //   }
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm.deptName = nodeTitle;
      this.selectForm.deptId = nodeId;
      console.log(node);
    },
    typeLazyLoadTree(node, resolve) {
      
          let id;
          if (node.level === 0) {
            id = 0;
          } else {
            id = node.data.id;
          }
          if(this.projectId){
            tree({ id: id, projectId: this.projectId, objectType: 1 }).then(({ data }) => {
              if (data instanceof Array) {
                data.forEach((item) => {
                  item.hasChildren = !item.hasChildren;
                });
              } else {
                data = [];
              }
              resolve(data);
            });
          }
      
    },
  },
};
</script>

<style scoped>
::v-deep .el-col-6{
  height: 54px;
}
::v-deep .avue-crud__right {
  display: flex;
}
</style>
